import { useSelector, useDispatch } from "react-redux";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Typography from "@mui/material/Typography";

import { uiActions } from "../../store";
import { faqItems } from "../../config/config.faq";

const Faq = () => {
  const showFaq = useSelector((state) => state.ui.showFaq);
  const dispatch = useDispatch();

  const handleCloseFaq = () => {
    dispatch(uiActions.setShowFaq(false));
  };

  return (
    <Dialog
      open={showFaq}
      onClose={handleCloseFaq}
      aria-labelledby="modal-frequently-asked-questions"
    >
      <DialogTitle sx={{ textAlign: "center" }}>
        Frequently Asked Questions
      </DialogTitle>
      <DialogContent>
        {faqItems.map((item) => {
          return (
            <Accordion key={item.id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`${item.id}-content`}
                id={`${item.id}-header`}
              >
                <Typography>{item.q}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ fontSize: "0.9rem" }}>{item.a}</Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button
          aria-label="close overlay selection"
          onClick={handleCloseFaq}
          sx={{ color: "primary.contrastText" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Faq;
